export default __webpack_public_path__ + "static/media/CNG.9b9ff921.svg";